import React, { useMemo, useEffect } from 'react';
import SubPage from '#/common/components/SubPage';
import ExpenseForm from '../components/ExpenseForm';
import useExpenseCreate from '../hooks/useExpenseCreate';
import type { Expense } from '#/graphql/types';
import newFields from '../components/ExpenseForm/new-fields';
import { useSearchParams } from 'react-router-dom';
import useWorkOrderQuery from '#/modules/workOrder/hooks/useWorkOrderQuery';

const NewExpensePage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const workOrderId = searchParams.get('workOrderId') || undefined;
  const tenantId = searchParams.get('tenantId') || undefined;
  const title = 'New Expense';

  const { data: queryData, loading: queryLoading } = useWorkOrderQuery(workOrderId ?? '', {
    skip: !!tenantId,
  });
  const tenantIdFromQuery = queryData?.getWorkOrder?.data?.tenantId;

  useEffect(() => {
    if (!tenantId && tenantIdFromQuery) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('tenantId', tenantIdFromQuery);
      setSearchParams(newSearchParams, { replace: true });
    }
  }, [tenantId, tenantIdFromQuery, searchParams, setSearchParams]);

  const newExpense = useMemo(() => {
    return {
      number: Math.floor(Math.random() * 10000),
      status: 'draft',
      workOrderId: workOrderId,
      tenantId: tenantId,
    } as Expense;
  }, [workOrderId, tenantId]);

  const { createExpense } = useExpenseCreate();

  return (
    <SubPage title={title} showGoBackButton type="form" isLoading={queryLoading}>
      <ExpenseForm title={title} expense={newExpense} fields={newFields} submit={createExpense} />
    </SubPage>
  );
};

export default React.memo(NewExpensePage);
